// extracted by mini-css-extract-plugin
export default {"auth-section":"AuthSection_auth-section__vs8We","login":"AuthSection_login__MMwBT","signup":"AuthSection_signup__8UFAL"};